import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OCMTypes, UpdateOcmError, UpdateOcmFirstLoad, UpdateOcmIsLoading, UpdateOcmPayload } from './ocm.types';

const initialState: OCMTypes = {
  data: {
    currentConsumptionAmount: 0,
    minimalAmount: 0,
    lastConsumptionAlertedDate: null,
  },
  isLoading: true,
  error: null,
  firstLoad: true,
  outOfSold: false,
  warningSold: false,
};

const ocmSlicer = createSlice({
  name: 'ocm',
  initialState,
  reducers: {
    updateOcmData: (state, action: PayloadAction<UpdateOcmPayload>) => {
      state.data = action.payload.data;
      state.outOfSold = state.data.currentConsumptionAmount === 0;
      state.firstLoad = false;
      state.warningSold = state.data.currentConsumptionAmount < action.payload.data.minimalAmount;
    },
    updateOcmIsLoading: (state, action: PayloadAction<UpdateOcmIsLoading>) => {
      state.isLoading = action.payload.isLoading;
    },
    resetOutOfSoldIndicators: (state, action: PayloadAction) => {
      state.outOfSold = false;
      state.warningSold = false;
    },
    updateOcmError: (state, action: PayloadAction<UpdateOcmError>) => {
      state.error = action.payload.error;
    },

    updateOcmFirstLoad: (state, action: PayloadAction<UpdateOcmFirstLoad>) => {
      state.firstLoad = action.payload.firstLoad;
    },
  },
});

export const { updateOcmData, updateOcmIsLoading, updateOcmError, updateOcmFirstLoad, resetOutOfSoldIndicators } =
  ocmSlicer.actions;
export const ocmReducer = ocmSlicer.reducer;
